'use strict';
import {AnalyticsUtils} from "../nddUtils/analyticsUtils.service";

var angular:angular.IAngularStatic =  require('angular');
const uiRouter = require('angular-ui-router');
import appConfigModule from '../appConfig/appConfig.module';
import  infraModule from '../infra/infra.module';
import {UserSessionManagerService} from '../security/userSessionManager.service';
import {UsernamePasswordLoginService} from '../security/usernamePasswordLogin.service';
import {PRODUCTION_MODE} from '../appConfig/productionMode';
import {PrimolyticsService} from '../analytics/primolytics.service';
import {AnalyticsUtils} from '../nddUtils/analyticsUtils.service';
import {getInjectableName as gI} from 'ng-metadata/core';
import {JwtUtilService} from '../security/jwtUtil.service';
import {LoginService} from '../security/login/login.service';
import securityModule from '../security/security.module';
import {
    getAutocompleteUrl,
    getGoogWithProxy,
    getInstitutionCode,
    getVid,
    getEnableResearchAssistantFor
} from '../appConfig/appConfigForward';
import {getViewSvg} from "../appConfig/customizationConfig";
import I18nModule from '../i18n/i18n.module';
import {DateUtils} from '../nddUtils/dateUtils.service';
import PrimoExploreStateModule from './primoExploreStates.module';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {isBrowserIE} from '../infra/browserSniffer'
import primoExploreComponentsModule from './primoExploreComponents.modules';
import {StorageUtil} from "../infra/storageUtil.service";
import {LoginIframeService} from './loginIframe.service';
import {PersonalizeResultsButtonService} from "../search/personalization/personalizationButton/personalizeResultsButton.service";
import {SharedSessionStorage} from '../infra/sharedSessionStorage.service';



let isIE = isBrowserIE();
const md5 = require('md5');

let dependenciesAngularArr = [
    uiRouter,
    primoExploreComponentsModule.name];

let dependenciesExploreArr = [
    PrimoExploreStateModule.name,
    I18nModule.name,
    appConfigModule.name,
    infraModule.name,
    securityModule.name,
];
let dependenciesArr = dependenciesAngularArr.concat(dependenciesExploreArr);

const app = angular.module('primo-explore.config', dependenciesArr);
export default app;
app.constant('$MD_THEME_CSS', '');
// ///**
// // * Mappings for the different routes in the application
// // * TThe intro route is planned to appear on the initial startup and the data will be saved to
// // * localstorage
// // * Then, on each startup the localstorage will be checked to see if the intro should be
// // * presented or not
// // */
// //
// ///**
// // * @ngdoc overview
// // * @name starter
// // * @module starter
// // * @description
// // *
// // * This is the main module of our application
// // *
// // */
// //

app.config(configurePrimoExplore)
    .run(runPrimoExplore);
///*.
// run(function($http, $templateCache){
// // Pre-fetch icons sources by URL and cache in the $templateCache...
// // subsequent $http calls will look there first.
// let urls = [ '../css/svg/svg-sprite-content.svg'];
// angular.forEach(urls, function(url) {
// $http.get(url, {cache: $templateCache});
// });
// });*/
///* jshint maxparams:7*/
////jscs:disable


function configurePrimoExplore($compileProvider, $httpProvider, $locationProvider, $mdGestureProvider, $mdInkRippleProvider,
                               $mdThemingProvider, $mdIconProvider, iconSets, $ariaProvider, $sceDelegateProvider:ng.ISCEDelegateProvider, $qProvider) {
    
    $qProvider.errorOnUnhandledRejections(false);
    $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        getAutocompleteUrl() + '**',
        getGoogWithProxy()+'**',
        'https://almad-test-st01.ext.exlibrisgroup.com/'+'**',
        'https://na-test-st01.ext.exlibrisgroup.com/'+'**',
		'https://ap-test-st01.ext.exlibrisgroup.com/'+'**',
		'https://eu-test-st01.ext.exlibrisgroup.com/'+'**',
		'https://ca-test-st01.ext.exlibrisgroup.com/'+'**',
		'https://cn-test-st01.ext.exlibrisgroup.com/'+'**',
		'https://na-st01.ext.exlibrisgroup.com/'+'**',
		'https://ap-st01.ext.exlibrisgroup.com/'+'**',
		'https://eu-st01.ext.exlibrisgroup.com/'+'**',
		'https://ca-st01.ext.exlibrisgroup.com/'+'**',
		'https://cn-st01.ext.exlibrisgroup.com/'+'**',
		'https://na-impl-st01.ext.exlibrisgroup.com/'+'**',
		'https://ap-impl-st01.ext.exlibrisgroup.com/'+'**',
		'https://eu-impl-st01.ext.exlibrisgroup.com/'+'**',
		'https://ca-impl-st01.ext.exlibrisgroup.com/'+'**',
		'https://www.youtube.com/embed/'+'**',
		'http://il-docker01.corp.exlibrisgroup.com:8182/'+'**',
        'https://upload.wikimedia.org/wikipedia/commons/4/41/Wikidata_Stamp_Rec_Light.svg'
    ]);
    //jscs:enable
    $httpProvider.useApplyAsync(true);
    $compileProvider.debugInfoEnabled(!PRODUCTION_MODE);
    /*
       https://stackoverflow.com/questions/50937725/angularjs-compileprovider-preassignbindingsenabled-is-not-a-function
       The $compileProvider.preAssignBindingsEnabled flag is deprecated in AngularJS V1.6 and has been removed from AngularJS V1.7.
    */
    if ($compileProvider.preAssignBindingsEnabled) {
        const testAngularCompatibility = getUrlParameter('testAngularCompatibility');
        if (testAngularCompatibility === 'true'){
            $compileProvider.preAssignBindingsEnabled(false);
        }
        else{
            $compileProvider.preAssignBindingsEnabled(true);
        }
	}

    //PRM-31585 - we don't use jquery, so we disable the hijacking of the clicks
    $mdGestureProvider.skipClickHijack();

    if(isIE) {
        $mdInkRippleProvider.disableInkRipple();
    }
    
	handleRapidoImplementationMode();
    
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
    // Extend the red theme with a few different colors
    let primoExplorePrimary = $mdThemingProvider.extendPalette('indigo', {
        '500': '#53738C'
    });
    let primoExploreAccent = $mdThemingProvider.extendPalette('indigo', {
        'A100': '#72B4BA',
        'A200': '#72B4BA',
        'A400': '#72B4BA',
        'A700': '#72B4BA'
    });
    // Register the new color palette map with the name <code>neonRed</code>
    $mdThemingProvider.definePalette('primoExplore', primoExplorePrimary);
    $mdThemingProvider.definePalette('primoExploreAccent', primoExploreAccent);
    // Use that theme for the primary intentions
    $mdThemingProvider.theme('primoExplore')
        .primaryPalette('primoExplore')
        .accentPalette('primoExploreAccent')
    /*.warnPalette('pink')*/
    /*.backgroundPalette('pink')*/;

    $mdThemingProvider.setDefaultTheme('primoExplore');


    // Configure URLs for icons specified by [set:]id.
    if (getViewSvg()) {
        iconSets.push(
            {
                type: 'svg',
                id: 'customIcons',
                link: 'https://www.google.com/design/icons',
                displayName: 'Customized icons',
                sets: [
                    {
                        set: 'custom-ui',
                        file: getViewSvg(),
                        size: 24
                    }
                ]
            }
        )
    }
    iconSets.map(function (iconSet) {
        iconSet.sets.map(function (iconset) {
            $mdIconProvider.iconSet(iconset.set, iconset.file, iconset.size);
        });

    });








    /*keeping the defaults for now*/
    /*$ariaProvider.config({
     bindKeypress: true,
     bindRoleForClick: true,
     ariaHidden: true,
     ariaChecked: true,
     ariaReadonly: true,
     ariaDisabled: true,
     ariaRequired: true,
     ariaInvalid: true,
     ariaValue: true,
     tabindex: true,
     bindKeypress: true,
     bindRoleForClick: true
     });
     */
}

configurePrimoExplore.$inject = [ '$compileProvider', '$httpProvider', '$locationProvider', '$mdGestureProvider', '$mdInkRippleProvider', '$mdThemingProvider',
    '$mdIconProvider', 'iconSets','$ariaProvider', '$sceDelegateProvider', '$qProvider'];

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null ? 'false' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function handleRapidoImplementationMode() {
	try {
    	window.sessionStorage.setItem("isRapido", getUrlParameter('Rapido'));
    } catch(err) {
    	//safari incognito will throw error here
    }
}

function runPrimoExplore($rootScope, $window, $state, $location, userSessionManagerService, LoginService, jwtUtilService, StorageUtil,
	                         usernamePasswordLoginService,primolyticsService, $mdDateLocaleProvider, dateUtils: DateUtils, restBaseURLs,
                             personalizeResultsButtonService, sharedSessionStorage, sessionTimeoutService,analyticsUtils) {

    
    sessionTimeoutService.startSession(userSessionManagerService.isGuest());



	window.onpageshow = function(event) {
		//fix for safari back forward cache problem
	    if (event.persisted) {
	        window.location.reload()
	    }
	};

    $mdDateLocaleProvider.formatDate= (date)=>dateUtils.convertDateTypeToFormatString(date, dateUtils.primoShortDateFormat);
    $mdDateLocaleProvider.parseDate= (date)=>dateUtils.convertDateStringToDate(date, dateUtils.primoShortDateFormat);

    $rootScope.$on('$stateChangeStart',

        ( event, toState, toParams, fromState, fromParams ) => {
            let userName = userSessionManagerService.getUserName();
            if ( toState.name === 'login' ) {
                // Deep link login page
                // Check if user already logged in
                if ( userName ) {
                    // User already logged in, redirect to targetURL
                    let targetURL = $location.search().targetURL;
                    if ( targetURL ) {
                        $window.location.assign( targetURL );
                    }
                    else if($location.search().toState && $location.search().toParams) {
                        event.preventDefault();
                        LoginService.loadSavedState($location.search().toState, JSON.parse($location.search().toParams));
                    }
                    else {
                        // No target url, redirect to search page
                        console.log( 'Error: no targetURL, redirect to home page' );
                        event.preventDefault();
                        let viewId = toParams.vid;
                        if ( viewId ) {
                            $state.go(STATE_NAMES.SEARCH, { vid: viewId } );
                        }
                        else {
                            console.log( 'Error: no vid, cannot redirect to home page' );
                        }
                    }
                }
            }
            else if ( toState.name === 'account' || (toState.name === STATE_NAMES.FAVORITES && $location.url().includes('section=queries'))
                || toState.name === STATE_NAMES.BLANK_ILL || toState.name === STATE_NAMES.PURCHASE_REQUEST || (toState.name === STATE_NAMES.RESEARCH_ASSISTANT && isSignInRequiredForResearchAssistant(jwtUtilService)) ) {
                if ( !userName ) {
                    // For my library, user must be logged in, if we did not come from
                    // a state, it means we need to show deep link login page

                    event.preventDefault();

                    // In some cases, there is an option to return back from the authentication system as a guest.
                    // In these cases, we want to redirect the user to the homepage.
                    // The indication for this, is a new flag we added to the target URL sent to the authentication system in the 'my account' case
                    if ($location.search().fromLogin) {
                        let params: any= {vid: $location.search().vid};
                        //Add this flag to the url so the bor-info alert will appear when we return to home page
                        if ($location.search().authenticationError) {
                            params.authenticationError = '1';
                        }
                        $state.go(STATE_NAMES.SEARCH, params, { reload: true } );
                    } else {
                        LoginService.toState = toState;
                        LoginService.toParams = toParams;
                        userSessionManagerService.prevTabDeeplink = $location.absUrl();

                        if ( fromState.name ) {
                            LoginService.callHandleLoginClickWithBeacon();
                        }
                        else {
                            let currentJwt = jwtUtilService.getJwtFromLocalStorage();
                            //prevent situation where a deep link to my account would redirect us to the wrong institution login page
                            if (currentJwt && !userSessionManagerService.isJWTValidForApp(currentJwt)){
                                userSessionManagerService.logout(true);
                            }
                            else{
                                $state.go( 'login', toParams );
                            }
                        }
                    }
                } else if ($location.search().fromLogin) {
                    $location.search('fromLogin', null);
                }
            }
            else if ( toState.name === 'deposit') {
                if ( !userName ) {
                    // For my library, user must be logged in, if we did not come from
                    // a state, it means we need to show deep link login page

                    event.preventDefault();

                    // In some cases, there is an option to return back from the authentication system as a guest.
                    // In these cases, we want to redirect the user to the homepage.
                    // The indication for this, is a new flag we added to the target URL sent to the authentication system in the 'my account' case
                    if ($location.search().fromLogin) {
                        $state.go(STATE_NAMES.SEARCH, { vid: $location.search().vid }, { reload: true } );
                    } else {
                        LoginService.toState = toState;
                        LoginService.toParams = toParams;
                        userSessionManagerService.prevTabDeeplink = $location.absUrl();

                        if ( fromState.name ) {
                            LoginService.callHandleLoginClickWithBeacon();
                        }
                        else {
                            let auth= $location.search().auth;
                            let returnURL = $location.absUrl();
                            let institutionCode = getInstitutionCode();
                            let url= '/deposit/login?institute=' +  institutionCode;
                            if (auth !== undefined){
                                url += '&auth=' + encodeURIComponent( auth );
                            }
                            $window.location.assign(url);
                        }
                    }
                } else if ($location.search().fromLogin) {
                    $location.search('fromLogin', null);
                }
            }
            // For PRM-40512 - Sticky facet improvment. We need to reset the sticky facets 
            // in case we came from a new search ('Library search' link)
            else if(toState.name === STATE_NAMES.SEARCH) {
                let query = toParams.query;
                if (!query) {
                    sharedSessionStorage.removeItem('stickyFacets');
                }
            }
        } );


    let jwt = $location.search().primoExploreJwt;
    if(getUrlParameter('jwt') !== 'false'){
    	jwt = getUrlParameter('jwt');
    }
    let loginId= $location.search().loginId;
    let isLoginProcess = false;
    if (loginId){ // if we received loginId param in url then we need to call server in order to get the jwt from the cache
        $location.search('loginId', null);
        let request = new XMLHttpRequest();
        //add the vid for suprima  since the jwt is saved in the DB, need to be able to do silent login in alma
        let vid = $location.search().vid;
        if(!vid){
        	if($location.path().includes('/delivery')){
				vid=appConfig.vid;
       		}
        
        }
        request.open('GET', restBaseURLs.loginJwtCache + '/' + loginId + '?vid=' +  vid, false); //call rest api synchronously (wait till response)
        request.send(null);
        if (request.status === 200) { //if call to rest api succeeded
            jwt= request.responseText;
            if(jwt){
                isLoginProcess = true;
            }
        }
        else{ //if call to rest api failed
            jwt = null;
        }
    }
    if (!jwt){
        jwt = jwtUtilService.getJwtFromLocalStorage()
    }
    if (jwt && userSessionManagerService.isJWTValidForApp(jwt)){
        performJwtActions(jwt, StorageUtil, usernamePasswordLoginService, $location, jwtUtilService, userSessionManagerService, primolyticsService,personalizeResultsButtonService, isLoginProcess);
    }
    else {
        userSessionManagerService.getGuestJwt().then((guestJwt)=>{
            console.log(guestJwt);
            performJwtActions(guestJwt, StorageUtil, usernamePasswordLoginService, $location, jwtUtilService, userSessionManagerService, primolyticsService,personalizeResultsButtonService, isLoginProcess);
            analyticsUtils.storeDeviceId(guestJwt);
        });
    }
    if ((!jwt || userSessionManagerService.isGuest(jwt)) && $location.search().authenticationError && $location.search().authenticationProfile && !sharedSessionStorage.getItem('loggedInIDP')){
        sharedSessionStorage.setItem('loggedInIDP', 'true');
        sharedSessionStorage.setItem('authenticationProfile', $location.search().authenticationProfile);
    }

}


function performJwtActions(jwt, StorageUtil, usernamePasswordLoginService, $location, jwtUtilService, userSessionManagerService, primolyticsService, personalizeResultsButtonService, isLoginProcess){
    if (jwt && !userSessionManagerService.isGuest(jwt) && isLoginProcess) { //we want to enter this code only if we are signed in
        //PDS
        StorageUtil.$localForage.keys().then((data) => {

            //delete userDetails
            let index = data.indexOf("userDetails");
            if (index > -1) {
                data.splice(index, 1);
            }

            //if there is no keys in local forage
            if (data.length === 0){
                usernamePasswordLoginService.getFavoritesFromServer();
                usernamePasswordLoginService.combineRecentScopeToSession({});
            }
            else if (data.length === 1) {
                usernamePasswordLoginService.copyFavoritesRecordsThatWereSavedForGuest(data[0]);
                usernamePasswordLoginService.changeSearchHistorylocalForageKey(data[0]);
                usernamePasswordLoginService.combineRecentScopeToSession(data[0]);
            }
            // in case there are more than one guest, need to sort and get the last guest
            else {
                let guests = data.filter(function (guest) {
                    if (guest.indexOf("anonymous-") != -1) {
                        return guest;
                    }
                });
                let dates = guests.map((guest) => guest.replace("anonymous-","").replace("_",""));
                let sorted = dates.sort(function (a, b) {
                    return b - a
                });
                //the format of guest is "anonymous-MMDD_HHMMSS"
                let user = "anonymous-"+sorted[0].substring(0,4)+"_"+sorted[0].substring(4,10);
                usernamePasswordLoginService.copyFavoritesRecordsThatWereSavedForGuest(user);
                usernamePasswordLoginService.changeSearchHistorylocalForageKey(user);
                usernamePasswordLoginService.combineRecentScopeToSession(user);
            }
        });
        $location.search('primoExploreJwt', null);
        $location.search('authenticationProfile', null);
        $location.search('from-new-ui', null);


        personalizeResultsButtonService.promise = personalizeResultsButtonService.updatePersonalization(getVid());
    }
    userSessionManagerService.login(jwt);

    primolyticsService.trackInitialPage();
}

function isSignInRequiredForResearchAssistant(jwtUtilService){
    let researchAssistantRequireSignIn = true;
    if(jwtUtilService.isSignedIn()){
        return false;
    }
    switch (getEnableResearchAssistantFor()) {
        case 'everyone':
            researchAssistantRequireSignIn = false;
            break;
        case 'on_campus':
            researchAssistantRequireSignIn = (jwtUtilService.getDecodedToken().onCampus == 'false');
            break;
        case 'users':
            researchAssistantRequireSignIn = jwtUtilService.isGuest();
            break;
    }
    return researchAssistantRequireSignIn;
}




runPrimoExplore.$inject = ['$rootScope', '$window', '$state', '$location', gI(UserSessionManagerService),
    gI(LoginService), gI(JwtUtilService), gI(StorageUtil),
    gI(UsernamePasswordLoginService),gI(PrimolyticsService),'$mdDateLocale', gI(DateUtils), 'restBaseURLs', gI(PersonalizeResultsButtonService),
    gI(SharedSessionStorage), 'SessionTimeoutService', gI(AnalyticsUtils)];



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreConfig.module.ts